import React, { useEffect, useContext, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetStores } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import { UserOrderContext } from 'context/context';
import {
  isEmptyObject,
  isEmptyEvery,
  getDispositionTypeOnAPIFormat,
  getDispositionFomat,
  setStoreOutOfService,
  isMobileDevice,
  localizeUserWithStoreInfo,
  goToMenuPage,
  getValueOrDefaultObject,
  getTernaryValue,
  getCheckIfAnyOnePass,
  getAndCheckIfOneTrue,
  checkByParams,
  safeUpperCase,
  isPickupDisposition,
  isDeliveryDisposition,
} from 'common/utilities/utils';
import MenuPDPContainer from 'organisms/MenuPDPPage/AU/Container/MenuPDPContainer';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';
import { StartOrderComponent } from 'organisms/StartOrderComponent';
import {
  BEFOREUNLOAD,
  LOCAL_STORAGE_KEYS,
  PICK_UP,
  RESIZE,
  ADD_TO_CART_DEEPLINK_TEXT,
  PRODUCT_PAGE,
  CATERING,
  MENU,
  NOT_APPLICABLE,
} from 'common/constants/SharedConstants';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { getDefaultDispositionData, checkIfCateringPage } from 'common/utilities/CateringPLPUtils';
import { addItemToCartAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { getFinalPayload, checkExcludedItem } from 'organisms/MenuPDPPage/AU/Utilities/MenuPDPUtils';
import { getSeoPageWithObject } from 'components/productDescriptionPage/Container/productDescriptionPage';
import { StructureData } from 'organisms/StructureDataComponent';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { menusNavRestrictionHandler } from 'organisms/MenusPLP/AU/MenusPlpUtilities/MenusPlpUtils';

export const startOrderComponentView = (segmentedHomePageData, userParams, DISPOSITION) => {
  return (
    <StartOrderComponent
      contentData={{
        segmentedHomePageData: segmentedHomePageData?.[DISPOSITION] ?? {},
        contentDispositionData: segmentedHomePageData?.[DISPOSITION] ?? {},
      }}
      userParams={userParams}
    />
  );
};

export const deepLinkWithPickupData = param => {
  const {
    storesWithStatus,
    userOrderStateDispatch,
    userParams,
    qParams,
    tenantReducer,
    history,
    setDeeplinkFlagAddToCart,
    params,
    dispatch,
    dispositionNew,
  } = param;
  if (storesWithStatus?.[0]?.summary?.status?.currentStatus !== START_ORDER_CONSTANTS.CLOSED) {
    const isAddToCartParams = getTernaryValue(qParams?.action === ADD_TO_CART_DEEPLINK_TEXT, true, false);
    userOrderStateDispatch({ type: START_ORDER_CONSTANTS.IS_DEEPLINK_URL, value: { isDeepLinkURL: true } });
    if (!userParams?.localized) {
      localizeUserWithStoreInfo({
        dispatch,
        service: qParams?.ordertype,
        storeId: qParams?.storeid,
        tenantId: tenantReducer?.tenantId,
        userOrderStateDispatch,
        userParams,
        shouldCheckDropOffAddress: false,
        history,
      });
      setDeeplinkFlagAddToCart(isAddToCartParams);
    } else if (userParams?.localized) {
      getAndCheckIfOneTrue(
        params?.storeInfo?.id !== qParams?.storeid,
        safeUpperCase(dispositionNew.type) !== safeUpperCase(qParams?.ordertype),
      )
        ? goToMenuPage(history)
        : setDeeplinkFlagAddToCart(isAddToCartParams);
    } else {
      goToMenuPage(history);
    }
  } else {
    userOrderStateDispatch({ type: START_ORDER_CONSTANTS.DISPOSITION_DATA, value: { showDisposition: true } });
  }
};

export const deepLinkWithDeliveryData = (userParams, storesWithStatus, userOrderStateDispatch, history, qParams) => {
  userOrderStateDispatch({ type: START_ORDER_CONSTANTS.IS_DEEPLINK_URL, value: { isDeepLinkURL: true } });
  if (!userParams?.localized) {
    if (storesWithStatus?.[0]?.summary?.status?.currentStatus !== START_ORDER_CONSTANTS.CLOSED) {
      userOrderStateDispatch({ type: START_ORDER_CONSTANTS.DISPOSITION_DATA, value: { showDisposition: true } });
    } else {
      goToMenuPage(history);
    }
  } else if (userParams?.localized && qParams?.ordertype !== NOT_APPLICABLE) {
    if (storesWithStatus?.[0]?.summary?.status?.currentStatus === START_ORDER_CONSTANTS.CLOSED) {
      userOrderStateDispatch({ type: START_ORDER_CONSTANTS.DISPOSITION_DATA, value: { showDisposition: true } });
    }
  }
};

const ProductDescriptionPage = props => {
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { menuNavRestricted } = userOrderState;
  const tenantReducer = useSelector(data => data.tenantReducer);
  const dispositionNew = getTernaryValue(
    isEmptyEvery(userOrderState?.dispositionNew),
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW)),
    userOrderState?.dispositionNew,
  );
  const currentItemObject = useSelector(({ menuReducer: { currentItemDetails } }) => currentItemDetails);

  const { flatResponse: { categoryMapByUrl = {} } = {} } = useSelector(({ menuReducer }) => menuReducer) ?? {};
  const { category_name, product_name } = useParams();
  const [seoPage, setSeoPage] = useState(PRODUCT_PAGE);
  const [seoObj, setSeoObj] = useState();
  const [isMobile, setMobileHeader] = React.useState(isMobileDevice(window.innerWidth));
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const userParams = useSelector(state => state?.appStateReducer?.userStatus);
  const miniPDPDataForCart = userOrderState?.pdpDataForUpdateFoodLine;
  const { pdpPayloadData, isDeepLinkURL } = userOrderState;
  const [isDeeplinkFlagAddToCart, setDeeplinkFlagAddToCart] = useState(false);
  const [isItemAvailable, setIsItemAvailable] = useState(false);
  const cartReducer = useSelector(data => data.cartReducer);
  const storesReducer = useSelector(data => data.storesReducer);
  const { storesWithStatus } = storesReducer;
  const { cartData = {} } = getValueOrDefaultObject(cartReducer);
  /**
   * Method call on window resize
   */
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  useEffect(() => {
    const { seoPageName, seoObject } =
      getSeoPageWithObject(tenantReducer, categoryMapByUrl, category_name, product_name) ?? {};
    setSeoObj(seoObject);
    setSeoPage(seoPageName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category_name, product_name, JSON.stringify(categoryMapByUrl)]);

  useEffect(() => {
    userOrderStateDispatch({
      type: MENU_PDP_PAGE_CONSTANTS.SET_PDP_PAGE_STATUS,
      value: { isPdpPageActive: true },
    });
    return () => {
      userOrderStateDispatch({
        type: MENU_PDP_PAGE_CONSTANTS.SET_PDP_PAGE_STATUS,
        value: { isPdpPageActive: false },
      });
      userOrderStateDispatch({
        type: MENU_PDP_PAGE_CONSTANTS.PDP_DATA_FOR_UPDATE_FOODLINE,
        value: { id: '', flag: '', foodLineId: '' },
      });
      userOrderStateDispatch({
        type: MENU_PDP_PAGE_CONSTANTS.SET_PDP_PROMO_MODE,
        value: { pdpPromoPage: false },
      });
      localStorage.removeItem(LOCAL_STORAGE_KEYS.VIEW_PRODUCT);
    };
  }, [userOrderStateDispatch]);

  useEffect(() => {
    const windowUnloadEventHandler = () => {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.VIEW_PRODUCT);
    };
    window.addEventListener(BEFOREUNLOAD, windowUnloadEventHandler);
    return () => {
      window.removeEventListener(BEFOREUNLOAD, windowUnloadEventHandler);
    };
  }, []);

  /**
   * Use to add window listner for windown size change
   */
  useEffect(() => {
    window.addEventListener(RESIZE, windowResized);
  }, [isMobile]);
  const params = useMemo(() => {
    const defaultDispositionData = getDefaultDispositionData({
      path: props?.location?.pathname,
      genericMenuName: tenantReducer?.genericMenuName,
      genericCateringName: tenantReducer?.genericCateringName,
      defaultdisposition: tenantReducer?.authoredContent?.defaultdisposition,
      defaultcateringdisposition: tenantReducer?.authoredContent?.defaultcateringdisposition,
    });
    const storeInfo = getValueOrDefaultObject(dispositionNew?.store);

    return {
      tenantReducer: getTernaryValue(
        isEmptyObject(tenantReducer),
        tenantReducer,
        JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.TENANT_REDUCER)),
      ),
      storeInfo,
      selectedDate: dispositionNew?.date,
      selectedTime: dispositionNew?.time,
      dispositionType: getTernaryValue(
        dispositionNew?.type,
        getDispositionTypeOnAPIFormat(dispositionNew?.type),
        getDispositionTypeOnAPIFormat(defaultDispositionData?.defaultdispostitionType),
      ),
      selectedTile: getTernaryValue(
        isEmptyObject(userOrderState?.selectedTile),
        userOrderState?.selectedTile,
        JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.SELECTED_TILE)),
      ),
      catalogs: getCheckIfAnyOnePass(
        storeInfo?.summary?.menu?.catalogs?.[0],
        defaultDispositionData?.defaultMenuName,
        '',
      ),
      isFromCatering: checkIfCateringPage(props?.location?.pathname),
    };
  }, [dispositionNew, tenantReducer, userOrderState, props?.location?.pathname]);

  /**
   * Check menu navigation restriction
   */
  useEffect(() => {
    let baseCategory = [{ url: getTernaryValue(dispositionNew?.type?.toLowerCase() === CATERING, CATERING, MENU) }];
    const paramsData = {
      pathname: location?.pathname,
      userParams,
      baseCategory,
      history: props?.history,
      menuNavRestricted,
      userOrderStateDispatch,
    };
    menusNavRestrictionHandler(paramsData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.pathname]);

  /**
   * Store Closed Callback
   */
  const setStoreClosedInfo = currentStoreInfo => {
    setStoreOutOfService(
      currentStoreInfo,
      userOrderStateDispatch,
      dispositionNew,
      getDispositionFomat(params.dispositionType),
    );
  };

  useEffect(() => {
    if (checkByParams(currentItemObject, isEmptyObject(pdpPayloadData), isDeepLinkURL)) {
      const { customizable, isExcluded } = currentItemObject;
      if (!isDeepLinkURL && getCheckIfAnyOnePass(isExcluded, checkExcludedItem(pdpPayloadData))) {
        goToMenuPage(history);
        return;
      }
      if (!customizable) {
        setIsItemAvailable(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentItemObject, pdpPayloadData, storesWithStatus, isDeepLinkURL]);

  useEffect(() => {
    const queryParams = location?.search?.split('?')[1];
    if (queryParams) {
      const urlSearchParams = new URLSearchParams(queryParams);
      const qParams = Object.fromEntries(urlSearchParams.entries());
      if (isPickupDisposition(qParams?.ordertype) && qParams?.storeid) {
        deepLinkWithPickupData({
          storesWithStatus,
          userOrderStateDispatch,
          userParams,
          qParams,
          tenantReducer,
          history,
          setDeeplinkFlagAddToCart,
          params,
          dispatch,
          dispositionNew,
        });
      }
      if ((isDeliveryDisposition(qParams?.ordertype) && qParams?.storeid) || qParams?.ordertype === NOT_APPLICABLE) {
        deepLinkWithDeliveryData(userParams, storesWithStatus, userOrderStateDispatch, history, qParams);
      }
    }
    return () => {
      dispatch(resetStores());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storesWithStatus?.[0]?.summary?.status?.currentStatus]);

  useEffect(() => {
    if (
      checkByParams(
        isItemAvailable,
        isDeeplinkFlagAddToCart,
        isEmptyObject(pdpPayloadData),
        cartData?.id,
        pdpPayloadData?.id,
      )
    ) {
      setDeeplinkFlagAddToCart(false);
      let payloaddata = getFinalPayload(pdpPayloadData);

      dispatch(
        addItemToCartAction(
          {
            params: {
              basketId: cartData?.id,
            },
            tenantId: tenantReducer?.tenantId,
          },
          [payloaddata],
          () => {
            goToMenuPage(history);
          },
        ),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, miniPDPDataForCart, pdpPayloadData, isDeeplinkFlagAddToCart, cartData, tenantReducer, isItemAvailable]);

  return (
    <React.Fragment>
      {seoObj && <StructureData page={seoPage} seoObj={seoObj} />}
      <MenuPDPContainer
        tenantData={tenantReducer}
        contentData={params}
        {...props}
        setStoreClosedInfo={setStoreClosedInfo}
      />
      {getTernaryValue(userOrderState.showCartClearAlert, <ClearCartModule />, null)}
    </React.Fragment>
  );
};

export default ProductDescriptionPage;
